import React, { useEffect, useState } from 'react';
import { withNotifications } from './notifications/NotificationsContext';

const HtmlListWithDisclosures = ({
  className,
  content,
  notifications,
  disclosures,
}) => {
  const ref = React.createRef();

  const [disclosureElements, setDisclosureElements] = useState([]);

  const getDisclosureElements = () => {
    const elements = Array.prototype.slice.call(
      ref.current?.querySelectorAll('a[disclosure]')
    );
    return elements;
  };

  const onDisclosureClick = (event) => {
    event.stopPropagation();
    const id = event.currentTarget.getAttribute('disclosure');
    const messageId = parseInt(id, 10);

    if (disclosures[messageId]) {
      notifications.show(disclosures[messageId], event, null, true);
    }
  };

  useEffect(() => {
    setDisclosureElements(getDisclosureElements);
  }, []);

  useEffect(() => {
    if (disclosureElements?.length > 0) {
      disclosureElements.forEach((el) => {
        el.addEventListener('click', onDisclosureClick);
      });

      return () => {
        disclosureElements.forEach((el) => {
          el.removeEventListener('click', onDisclosureClick);
        });
      };
    }
  }, [disclosureElements]);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: content }}
      ref={ref}
      className={className || ''}
    />
  );
};

export default withNotifications(HtmlListWithDisclosures);
